<template>
	<dialog-slot
			:title="title"
			@updateClose="onClose"
			@updateSave="onSave"
			width="780px"
			is-cancel-hide
			apply-text="Close"
	>
		<no-info
				v-if="isEmpty"
				padding="0"
				:text="textNoInfo"
		/>
		<main-table
				v-else
				padding="0"
				:flag="flag"
				:headers="headers"
				:listItems="items"
				:filtersList="{}"
				:is-hide-header="false"
				:items-per-page-amount="10"
				:pages="[ 10, 20, 50, 100, 200, 500, 'All' ]"
				@updateClickButton="onClickButton"
		></main-table>
	</dialog-slot>
</template>

<script>

import DialogSlot from "@/shared/DialogSlot/DialogSlot.vue";
import NoInfo from "@/shared/NoInfo/NoInfo.vue";

export default {
	name: "DialogInfoTable",
	components: { NoInfo, DialogSlot },
	computed: {
		isEmpty() {
			return !Array.isArray(this.items) || this.items.length === 0;
		}
	},
	props: {
		flag: String,
		title: String,
		textNoInfo: String,
		headers: Array,
		items: Array,
		width: String
	},
	methods: {
		onClose(type) {
			this.$emit('updateClose', type);
		},
		onSave() {
			this.$emit('updateSave');
		},
		onClickButton() {
			this.$emit('updateClickButton');
		}
	}
};
</script>

<style lang="scss" scoped>
</style>

